(function () {
  var SECTIONS = 'gg-cart-drawer,cart-page';

  function t(key) {
    var strings = window.ggCartStrings || {};
    return strings[key] || key;
  }

  function errorSlot(form) {
    return form.querySelector('[data-add-to-cart-error]');
  }

  function setLoading(form, loading) {
    var btn = form.querySelector('[type="submit"]');
    if (!btn) return;
    // target the dedicated label span so we never touch a sibling visually-hidden a11y span
    var label = btn.querySelector('[data-cart-btn-label]') || btn;
    if (loading) {
      label.dataset.ggLabel = label.dataset.ggLabel || label.textContent;
      label.textContent = t('adding');
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
    } else {
      if (label.dataset.ggLabel) label.textContent = label.dataset.ggLabel;
      btn.disabled = false;
      btn.removeAttribute('aria-busy');
    }
  }

  function showError(form, message) {
    var slot = errorSlot(form);
    if (slot) {
      slot.textContent = message;
      slot.hidden = false;
    }
  }

  function clearError(form) {
    var slot = errorSlot(form);
    if (slot) {
      slot.textContent = '';
      slot.hidden = true;
    }
  }

  function updateCartCount(count) {
    // scoped to `span` so this never matches the `<gg-drawer data-cart-count>` root itself
    document.querySelectorAll('span[data-cart-count]').forEach(function (el) {
      el.textContent = count;
    });
  }

  function refreshDrawer(html) {
    var drawer = document.getElementById('gg-cart');
    if (!drawer || !html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var freshPanel = doc.querySelector('#gg-cart .gg-drawer__panel');
    var panel = drawer.querySelector('.gg-drawer__panel');
    if (freshPanel && panel) panel.innerHTML = freshPanel.innerHTML;
    var freshRoot = doc.getElementById('gg-cart');
    if (freshRoot && freshRoot.dataset.cartCount !== undefined) {
      drawer.dataset.cartCount = freshRoot.dataset.cartCount;
      updateCartCount(freshRoot.dataset.cartCount);
    }
  }

  function refreshCartPage(html) {
    var container = document.getElementById('gg-cart-page');
    if (!container || !html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.getElementById('gg-cart-page');
    if (fresh) container.innerHTML = fresh.innerHTML;
  }

  function refreshSections(sections) {
    if (!sections) return;
    refreshDrawer(sections['gg-cart-drawer']);
    refreshCartPage(sections['cart-page']);
  }

  // Re-syncs the drawer/cart page to the real server state without changing the cart -
  // used after a rejected quantity change so a now-invalid input value doesn't linger on screen.
  function resyncCart() {
    fetch(window.routes.cart_url + '?sections=' + SECTIONS, { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.json();
      })
      .then(refreshSections)
      .catch(function () {});
  }

  function endpointFor(form) {
    return form.matches('.gg-cart-qty-form') ? window.routes.cart_change_url : window.routes.cart_add_url;
  }

  function handleSubmit(e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.matches('#GGProductForm, .gg-quick-add, .gg-cart-qty-form')) return;

    e.preventDefault();
    var isQtyChange = form.matches('.gg-cart-qty-form');
    var onCartPage = !!document.getElementById('gg-cart-page');
    clearError(form);
    setLoading(form, true);

    var formData = new FormData(form);
    formData.set('sections', SECTIONS);

    fetch(endpointFor(form), {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData,
    })
      .then(function (response) {
        return response.json().then(function (body) {
          return { ok: response.ok, body: body };
        });
      })
      .then(function (result) {
        if (!result.ok) {
          setLoading(form, false);
          // a 422 from add/change is almost always a stock limit, not a random failure -
          // prefer Shopify's own (already-localized) message, but fall back to the same
          // stock message everywhere (product page, quick add, cart line) for consistency
          showError(form, result.body.description || result.body.message || t('insufficient_stock'));
          if (isQtyChange) resyncCart();
          return;
        }
        // The Section Rendering API only re-renders sections embedded in theme.liquid/section
        // groups (like gg-cart-drawer), not sections scoped to a page template (like the cart
        // page's own "cart-page" section) - Shopify silently returns null for it. Reload for
        // correct data instead of leaving stale prices/cross-sell on screen.
        if (onCartPage) {
          window.location.reload();
          return;
        }
        setLoading(form, false);
        refreshSections(result.body.sections);
        // Lets other parts of the page (e.g. the product page stock limit) recount the cart.
        document.dispatchEvent(new CustomEvent('gg:cart-updated'));
        if (!isQtyChange) {
          var drawer = document.getElementById('gg-cart');
          if (drawer && typeof drawer.show === 'function') drawer.show();
        }
      })
      .catch(function () {
        setLoading(form, false);
        showError(form, t('add_error'));
        if (isQtyChange) resyncCart();
      });
  }

  function handleCrossSellArrowClick(e) {
    var btn = e.target.closest('[data-cross-scroll]');
    if (!btn) return;
    var carousel = btn.closest('.gg-cart-cross__carousel');
    var track = carousel && carousel.querySelector('.gg-cart-cross__grid');
    if (!track) return;
    var dir = parseInt(btn.dataset.crossScroll, 10) || 1;
    track.scrollBy({ left: dir * track.clientWidth, behavior: 'smooth' });
  }

  document.addEventListener('submit', handleSubmit);
  document.addEventListener('click', handleCrossSellArrowClick);
})();
